import { render } from "./OrderDetailShop.vue?vue&type=template&id=18ab47f0"
import script from "./OrderDetailShop.vue?vue&type=script&lang=js"
export * from "./OrderDetailShop.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__